module.exports = __webpack_public_path__ + "img/JYFH.f4656520.jpg";